import React from 'react';
import { Modal, CustomModalLayout } from '@wix/design-system';

interface IAppSettingsModalProps {
  settingsUrl: string;
  closeModal(): void;
}
const NewAppSettingsModal = (props: IAppSettingsModalProps) => {
  const { settingsUrl, closeModal } = props;

  React.useEffect(
    () =>
      window.addEventListener('message', (msg) => {
        return () => window.removeEventListener('message', () => closeModal());
      }),
    [],
  );

  return (
    <CustomModalLayout
      onCloseButtonClick={closeModal}
      removeContentPadding
      width="600px"
    >
      <iframe src={settingsUrl} width="100%" height="463px" frameBorder="0" />
    </CustomModalLayout>
  );
};

export default NewAppSettingsModal;
